"use client";

import {
  getProductByName,
} from "@/helpers/server-actions/stripe-collections";
import RedirectToStripe from "./RedirectToStripe";
import { useEffect, useState } from "react";
import { ExtendedLineItem } from "@/models/pass";

type CheckoutArg = {
  pass: string;
  quantity: number;
};

type StripeCheckoutSessionPropType = {
  passes: CheckoutArg[];
};

export default function StripeCheckoutSession({
  passes,
}: StripeCheckoutSessionPropType) {
  const [lineItems, setLineItems] = useState<ExtendedLineItem[] | null>(null);
  const [isLoadComplete, setIsLoadComplete] = useState<boolean>(false);

  useEffect(() => {
    loadCheckout();
  }, []);

  const loadCheckout = async () => {
    let tempLineItems: ExtendedLineItem[] = [];
    for (let i = 0; i < passes.length; i++) {
      const pass = passes[i].pass;
      const quantity = passes[i].quantity;

      const stripeProductDetails = await getProductByName(pass);
      if (stripeProductDetails.prices.length === 0) {
        continue;
      }
      tempLineItems.push({
        price: stripeProductDetails.prices[0].id,
        quantity: quantity,
        adjustable_quantity: {
          enabled: true,
          minimum: 1,
          maximum: 10,
        },
      });

    }

    setLineItems(tempLineItems);

    setIsLoadComplete(true);
  };

  if (!isLoadComplete) return <></>;

  if (lineItems && lineItems.length > 0) {
    return (
      <RedirectToStripe
        lineItems={lineItems}
      ></RedirectToStripe>
    );
  }

  return <div>Payment Gateway Issue</div>;
}
